import logger from '3-foundation/Logging/logger';
import { queryContentApi } from '3-foundation/ContentApi/queryContentApi';

export interface NavigationAdapterRequestInterface {
	preview: boolean;
	previewData: Content.PreviewData;
}

export interface NavigationAdapterResponseInterface {
	properties: Record<string, unknown>;
	children: Array<NavigationAdapterResponseInterface>;
	id: number;
	culture: string;
	name: string;
	url: string;
	documentType: string;
	template: string;
	createDate: string;
	sortOrder: number;
}

// Function to transform JSON to a more friendly structure
// Basically this just replaces children with descendants
// but could completely transform the JSON if desired
const transform = (item): Array<Navigation.NavigationItem> => {
	return item?.map((child: Navigation.NavigationItem & { children: Navigation.NavigationItem[] }) => {
		if (!child) return null;
		const { id, name, url, hidden, title, children } = child ?? {};
		return {
			id,
			name,
			url,
			hidden,
			title,
			descendants: children ? transform(children) : [],
		};
	});
};

export const getCmsNavigation = async ({ preview, previewData }: NavigationAdapterRequestInterface): Promise<Navigation.NavigationItem> => {
	const path = '/';
	const method = 'POST';
	const query = `{
		navigation: navigation(path: "${path}" maxDepth: 5 includeHidden : true)
	}`;

	const profiler = logger.startTimer();

	try {
		const content: { navigation: NavigationAdapterResponseInterface } = await queryContentApi({ method, query, preview, previewData });
		const transformedData: Navigation.NavigationItem = {
			...transform([content?.navigation])[0],
		};
		return transformedData;
	} finally {
		profiler.done({ message: 'getNavigation', level: 'debug' });
	}
};
